import produce from 'immer';

import { Types as SignOutTypes } from '../signout/actions';
import { Types as ClientTypes } from './actions';

const INITIAL_STATE = {
  loading: false,
  clients: [],
};

export default function fetchClients(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ClientTypes.FETCH_CLIENTS_REQUEST:
      return produce(state, (draft) => {
        draft.loading = true;
      });
    case ClientTypes.FETCH_CLIENTS_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.clients = action.payload;
      });
    case ClientTypes.FETCH_CLIENTS_FAILURE:
      return produce(state, (draft) => {
        draft.loading = false;
      });

    /**
     *
     */
    case ClientTypes.CREATE_CLIENTS_REQUEST:
      return produce(state, (draft) => {
        draft.loading = true;
      });
    case ClientTypes.CREATE_CLIENTS_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.clients.push(action.payload);
      });
    case ClientTypes.CREATE_CLIENTS_FAILURE:
      return produce(state, (draft) => {
        draft.loading = false;
      });

    /**
     *
     */
    case ClientTypes.UPDATE_CLIENTS_REQUEST:
      return produce(state, (draft) => {
        draft.loading = true;
      });

    case ClientTypes.UPDATE_CLIENTS_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.clients = draft.clients.map((element) => (element.id === action.payload.id ? action.payload : element));
      });
    case ClientTypes.UPDATE_CLIENTS_FAILURE:
      return produce(state, (draft) => {
        draft.loading = false;
      });

    /**
     *
     */
    case ClientTypes.DESTROY_CLIENTS_REQUEST:
      return produce(state, (draft) => {
        draft.loading = true;
      });

    case ClientTypes.DESTROY_CLIENTS_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.clients = draft.clients.filter((element) => element.id !== action.payload.id);
      });
    case ClientTypes.DESTROY_CLIENTS_FAILURE:
      return produce(state, (draft) => {
        draft.loading = false;
      });

    /**
     * SIGN OUT
     */
    case SignOutTypes.SIGN_OUT_SUCCESS:
      return INITIAL_STATE;
    default:
      return state;
  }
}
